import styled from "styled-components"
import media from "styled-media-query"

export const Wrapper = styled.div`
  width: 100%;

  ${media.lessThan("large")`
  `}

  section:nth-of-type(2) {
    margin-bottom: 40px;
  }

  ${media.lessThan("medium")`
    .contact {
      text-align: center;
    }
  `}
`

export const Content = styled.div`
  max-width: 1190px;
  margin: 0 auto;
  padding: 0 10px 0 15px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  ${media.lessThan("large")`
    padding: 0 20px;
  `}
`

export const Infos = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px;
  ${media.lessThan("medium")`
    margin-top: 25px;
  `}
`

export const Section = styled.section`
  p:nth-of-type(1) {
    max-width: 100%;
    margin-bottom: 20px;
  }

  p:nth-of-type(2) {
    max-width: 100%;
    margin-bottom: 20px;
  }

  &.skills {
    ${media.greaterThan("small")`
      margin-top: 20px;
    `}
  }

  ${media.lessThan("780px")`
  p, p:nth-of-type(1) {
    max-width: 100%;
    margin: 0 auto;
    margin-bottom: 20px;
  }
  `}
`

export const Title = styled.h1`
  font-weight: 500;
  font-size: 36px;
  line-height: 49px;
  color: var(--greenToBlack);
  margin: 20px 0 15px;

  ${media.lessThan("medium")`
    text-align: center;
    font-size: 30px;
    line-height: 55px;

    &.who {
      margin: 10px 0 20px;
    }
  `}
`
export const Text = styled.p`
  font-size: 18px;
  line-height: 26px;
  color: var(--whiteToBlack);

  ${media.greaterThan("small")`
    text-align: justify;
  `}

  &.contact {
    ${media.lessThan("small")`
      text-align: center;
    `}
  }
`

export const List = styled.ul`
  ${media.greaterThan("medium")`
    margin-top: 25px;
  `}
  ${media.lessThan("medium")`
    margin-top: 20px;
    padding-left: 15px;
  `}
`

export const Skill = styled.li`
  color: var(--whiteToBlack);
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  svg {
    color: #00d07e;
    width: 20px;
    margin-right: 5px;
  }
`

export const Contacts = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;

  margin-bottom: 40px;

  ${media.lessThan("medium")`
    align-items: center;
    flex-direction: column;
  `}
`

export const Contact = styled.section`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: auto;
  height: 120px;
  background: #0001;
  border-radius: 2px;
  padding: 15px;
  margin: 10px;

  ${media.lessThan("medium")`
    margin: 15px 0;
    width: 80%;
    max-width: 400px;
  `}

  ${media.greaterThan("medium")`
    margin: 30px 20px;
    width: 300px;
  `}

  ${media.greaterThan("large")`
    margin: 30px 20px;
    width: 300px;
  `}
`

export const Name = styled.h2`
  color: var(--whiteToBlack);
  font-weight: 400;
  font-size: 22px;
  text-align: center;
  width: 100%;
  border-bottom: 1px solid #0002;
  padding-bottom: 12px;
`

export const Social = styled.ul`
  display: flex;
  align-items: center;
  margin-top: 14px;

  li:not(:last-child) {
    margin-right: 20px;
  }

  li:nth-child(1) {
    width: 40px;
  }

  li:nth-child(2) {
    width: 30px;
  }

  li:nth-child(3) {
    width: 42px;
  }
`

export const SocialItem = styled.li`
  cursor: pointer;
`

export const SocialItemLink = styled.a`
  color: var(--socialIcons);

  &:hover {
    color: var(--highlight);
  }
`
